<template>
  <el-container>
    <el-main>
      <el-row type="flex" justify="space-start" :gutter="30">
        <el-col :span="18">
          <el-card class="box-card">
            <div class="card-header">
              <h4 class="card-title">Flexible Classroom Orders</h4>
            </div>
            <ApolloQuery :query="require('./products.gql')">
              <template slot-scope="{ result: { data } }">
                <label class="control-label">Filter By Product</label>
                <br />
                <el-select
                  v-model="searchProduct"
                  size="mini"
                  class="form-group border-input"
                  placeholder="Select Status"
                >
                  <el-option label="All" value></el-option>

                  <el-option
                    v-for="(product,index) in data.Product"
                    :key="index"
                    :label="product.name"
                    :value="product.name"
                  ></el-option>
                </el-select>
              </template>
            </ApolloQuery>

            <div class="table-responsive">
              <ApolloQuery
                :query="searchProduct!==''?require('./flexiblesByProduct.gql'):require('./flexibles.gql')"
                :variables="searchProduct!==''? {product:searchProduct}:null"
                 notifyOnNetworkStatusChange
           :fetch-policy="'no-cache'"
              >
                <template slot-scope="{ result: { loading, error, data} }">
              {{loading}}   
                  <div v-if="loading" >Loading...</div>
     <div v-else-if="error">{{error}}</div>
                  <div v-else-if="data">
                    <h4>Total: {{data.Order.length}}</h4>
                    <data-tables-server
                      class="table-shopping"
                      style="width: 100%"
                      :data="data.Order"
                      :tool-bar="true"
                      :current-page="1"
                      :total="data.Order.length"
                      :loading="loading"
                      :page-size="data.Order.length"
                      :pagination-props="{ pageSizes: [50,100] }"
                    >
                      <el-table-column prop="dateCreated" label="Date" min-width="40">
                        <template
                          slot-scope="props"
                        >{{props.row.dateCreated | moment('YYYY-MM-DD')}}</template>
                      </el-table-column>

                      <el-table-column label="Name" min-width="60">
                        <template
                          slot-scope="props"
                        >{{props.row.customer.firstname}} {{props.row.customer.lastname}}</template>
                      </el-table-column>

                      <el-table-column label="Email" min-width="75">
                        <template slot-scope="props">{{props.row.customer.email}}</template>
                      </el-table-column>
                      <el-table-column prop="product" label="Product" min-width="100">
                        <template slot-scope="props">{{props.row.boughtProducts[0].product.name}}</template>
                      </el-table-column>
                      <el-table-column
                        prop="customer.orders[0].dateCreated"
                        label="Status"
                        min-width="40"
                      >
                        <template slot-scope="props">
                          <span v-if="props.row.status=='2'">Fully paid</span>
                          <span v-if="props.row.status=='1'">Deposit paid</span>
                        </template>
                      </el-table-column>

                      <el-table-column label="Edit" min-width="50">
                        <template slot-scope="props">
                          <router-link :to="'/order/edit/'+props.row.id">Edit</router-link>
                        </template>
                      </el-table-column>
                    </data-tables-server>
                  </div>
                  <div v-else class="no-result apollo">No result :(</div>
                </template>
              </ApolloQuery>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      searchProduct: "",

    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Reports/Flexibles.vue